import { MapPin, User } from 'lucide-react';
import { Heading, Text, Stack } from '@/components/ui/index.js';
import styles from './ProfileHeader.module.css';

/**
 * ProfileHeader - User profile header with avatar glow effect
 * 
 * Features:
 * - Large avatar with neon glow ring and pulse animation
 * - Online status indicator
 * - User name and username
 * - Bio and location
 * - Edit profile button
 */
export function ProfileHeader({
  name,
  username,
  bio,
  location,
  avatar,
  isOnline,
  onEditProfile,
}) {
  return (
    <header className={styles.header}>
      <Stack direction="column" gap={4} align="center">
        {/* Avatar with Glow Ring */}
        <div className={styles.avatarWrapper}>
          <div className={styles.avatarRing}>
            <div className={styles.avatarGlow} />
            <div className={styles.avatar}>
              {avatar ? (
                <img src={avatar} alt={name} className={styles.avatarImage} />
              ) : (
                <User size={48} className={styles.avatarIcon} />
              )}
            </div>
          </div>
          {/* Online Status Indicator */}
          {isOnline && (
            <span className={styles.onlineIndicator} title="Online" />
          )}
        </div>

        {/* User Info */}
        <Stack direction="column" gap={1} align="center" className={styles.userInfo}>
          <Heading level={1} size="xl" color="primary" align="center">
            {name}
          </Heading>
          <Text size="base" color="muted" align="center">
            {username}
          </Text>
        </Stack>

        {/* Bio */}
        <Text size="base" color="secondary" align="center" className={styles.bio}>
          {bio}
        </Text>

        {/* Location */}
        <div className={styles.location}>
          <MapPin size={16} className={styles.locationIcon} />
          <Text size="sm" color="muted">
            {location}
          </Text>
        </div>

        {/* Edit Profile Button */}
        <button className={styles.editButton} onClick={onEditProfile}>
          <Text size="sm" weight="medium">Edit Profile</Text>
        </button>
      </Stack>
    </header>
  );
}

export default ProfileHeader;
